import { render, staticRenderFns } from "./PriceRecordDialog.vue?vue&type=template&id=f16df912"
import script from "./PriceRecordDialog.vue?vue&type=script&lang=js"
export * from "./PriceRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./PriceRecordDialog.vue?vue&type=style&index=0&id=f16df912&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f16df912')) {
      api.createRecord('f16df912', component.options)
    } else {
      api.reload('f16df912', component.options)
    }
    module.hot.accept("./PriceRecordDialog.vue?vue&type=template&id=f16df912", function () {
      api.rerender('f16df912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jdStore/samSrot/components/PriceRecordDialog.vue"
export default component.exports